import React from 'react';

const Tabs = ({ activeTab, onTabChange }) => {
  const tabs = ['Today', 'Yesterday', 'This Week', 'This Year'];

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabChange(tab)}
          style={{
            padding: '10px 20px',
            margin: '0 5px',
            width:'100%',
            backgroundColor: 'none',
            background:'none',
            color: 'black',
            borderBottom: activeTab === tab ? '4px solid blue' : 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
